<template>
    <el-dialog
        title="在线反馈"
        :visible.sync="visibleModel"
        :append-to-body="true"
        :close-on-click-modal="false"
        top="5vh"
        width="600px">
        <el-form :model="feedbackForm" :rules="rules" ref="form" label-width="100px" class="feedback-form"
                 label-position="left">
            <el-form-item label="反馈类型" prop="type">
                <el-radio-group v-model="feedbackForm.type" @change="formChange()">
                    <el-radio :label="1">使用问题</el-radio>
                    <el-radio :label="2">需求建议</el-radio>
                    <el-radio :label="3">合作意向</el-radio>
                    <el-radio :label="4">其他</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="反馈内容" prop="content">
                <el-input type="textarea" :rows="5" v-model="feedbackForm.content" @change="formChange()" placeholder="请详细描述您的问题便于我们为您提供更精准的服务"></el-input>
            </el-form-item>
            <el-form-item label="上传附件" prop="attach">
                <el-upload
                    ref="upload"
                    action=""
                    :data="attachData"
                    :auto-upload="false" multiple :limit="3" :http-request="request"
                    :on-exceed="handleExceed" :on-change="handleChange" :on-remove="handleRemove"
                    :on-success="uploadSuccess" :on-error="uploadError">
                    <el-button class="attach-btn" slot="trigger" size="small" type="primary">上传</el-button>
                    <div slot="tip" class="el-upload__tip" v-show="tipVisible">上传附件支持({{accept.join('、').replace(/\./g, '')}})等格式，最大不超过5M</div>
                </el-upload>
            </el-form-item>
            <el-form-item label="您的姓名" prop="name">
                <el-input v-model="feedbackForm.name" @change="formChange()" placeholder="请输入您的姓名，方便我们称呼"></el-input>
            </el-form-item>
            <el-form-item label="您的邮箱" prop="email">
                <el-input v-model="feedbackForm.email" @change="formChange()" placeholder="请输入您的邮箱，方便我们及时向您反馈"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" class="submit-btn" @click="beforeSubmit()" :loading="submitLoading">提交</el-button>
            </el-form-item>
            <el-form-item label="温馨提示">
                <div>1.我们将会尽快处理您的反馈（工作时间：周一至周五9:30-18:00）</div>
                <div>2.紧急问题建议您咨询人工客服</div>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
export default {
    data () {
        return {
            accept: ['.png','.jpg','.jpeg','.bmp','.gif','.txt','.doc','.xls','.docx','.xlsx','.pdf','.zip','.rar'],
            feedbackForm: {
                content: '',
                name: '',
                email: ''
            },
            rules: {
                type: [
                    {required: true, message: '请选择反馈类型', trigger: 'change'}
                ],
                content: [
                    {required: true, message: '请输入反馈内容', trigger: 'blur'}
                ],
                name: [
                    {required: true, message: '请输入您的姓名', trigger: 'blur'}
                ],
                email: [
                    {required: true, message: '请输入您的邮箱', trigger: 'blur'},
                    {type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur,change'}
                ]
            },
            tipVisible: true,
            attachData: {},
            submitLoading: false
        }
    },
    computed: {
        ...mapState(['user', 'feedbackVisible']),
        ...mapGetters(['getRandomWord']),
        visibleModel: {
            get: function () {
                return this.feedbackVisible;
            },
            set: function (val) {
                this.setFeedback(val);
            }
        }
    },
    mounted () {
        this.setStorage();
    },
    watch: {
        user () {
            if (this.user._id) {
                this.setStorage();
            } else {
                this.clear();
            }
        },
    },
    methods: {
        ...mapMutations(['setFeedback']),
        ...mapActions('qiniu', ['getUpToken', 'uploadFile']),
        ...mapActions(['postFeedback']),
        setStorage () {
            let storage = localStorage['xw-feedback' + this.user._id];
            if (storage) {
                this.feedbackForm = JSON.parse(storage);
            }
        },
        formChange () {
            localStorage['xw-feedback' + this.user._id] = JSON.stringify(this.feedbackForm);
        },
        handleChange (file, fileList) {
            let suffix = file.raw.name.replace(/.+\./, '.');
            if (this.accept.indexOf(suffix) === -1) {
                fileList.splice(fileList.indexOf(file), 1);
                this.$message.warning(`附件格式支持${this.accept.toString()}`);
            } else if (file.size > 5 * 1024 * 1000) {
                fileList.splice(fileList.indexOf(file), 1);
                this.$message.warning(`单个附件最大不超过5M`);
            }
            this.tipVisible = !fileList.length;
        },
        handleRemove (file, fileList) {
            this.tipVisible = !fileList.length;
        },
        handleExceed () {
            this.$message.warning(`最大上传附件数量为3个`);
        },
        async uploading () {
            let fileToken = await this.getUpToken();
            this.attachData.token = fileToken.uptoken;
            this.$refs.upload.submit();
        },
        async request (req) {
            let suffix = req.file.name.replace(/.+\./, '.');
            let fileName = 'feedback-' + this.getRandomWord() + suffix;
            const formData = new FormData();
            formData.append('key', fileName);
            formData.append('name', fileName);
            formData.append('token', req.data.token);
            formData.append('file', req.file);
            formData.append('accept', req.file.type);
            let res = await this.uploadFile(formData);
            return res.data;
        },
        uploadSuccess (response, file, fileList) {
            let successCount = fileList.filter(item => !!item.response);
            if (successCount.length === fileList.length) {
                this.feedbackForm.attach = fileList.map(item => {
                    return {filename: item.name, path: item.response.key};
                });
                this.submit();
            }
        },
        uploadError () {
            this.submitLoading = false;
            this.$message.error('提交反馈失败');
        },
        beforeSubmit () {
            this.$refs['form'].validate((valid) => {
                if (!valid) {
                    return false;
                }
                this.submitLoading = true;
                if (this.$refs.upload.uploadFiles.length) {
                    this.uploading();
                } else {
                    this.submit();
                }
            });
        },
        async submit () {
            try {
                await this.postFeedback(this.feedbackForm);
                this.clear();
                this.visibleModel = false;
                this.$message.success('提交反馈成功');
            } catch (err) {
                this.$message.error('提交反馈失败');
            }
            this.submitLoading = false;
        },
        clear () {
            localStorage.removeItem('xw-feedback' + this.user._id);
            this.$refs['form'] ? this.$refs['form'].resetFields() : '';
            this.feedbackForm = {content: '', name: '', email: ''};
            this.$refs.upload ? this.$refs.upload.clearFiles() : '';
        }
    }
}
</script>

<style lang="scss" scoped>
    .feedback-form {
        .attach-btn {
            width: 6.2rem;
            height: 2rem;
            font-size: .8rem;
            border-color: #00a0ff;
            background-color: #00a0ff;
        }
        .el-upload__tip {
            line-height: 22px;
        }
        .submit-btn {
            width: 8.5rem;
        }
    }
</style>
<style lang="scss">
    .feedback-form {
        .el-form-item__label {
            color: #999;
        }
        .el-form-item:last-child {
            margin-bottom: 0;
        }
    }
</style>



// WEBPACK FOOTER //
// app/components/Feedback.vue